const ORIGIN_TYPE_MAP: Record<string, string> = {
    WEB: 'Online',
    TEL: 'Phone',
    PPD: 'In Person',
    CCD: 'Corporate',
}

export function getOriginTypeLabel(code: string | null | undefined): string {
    if (!code) return '—'
    return ORIGIN_TYPE_MAP[code.toUpperCase()] ?? code
}
